module.exports = __webpack_public_path__ + "static/media/eco-ecology-island-svgrepo-com.7e2818f1.svg";